import { Skeleton } from '@/components/ui';

/**
 * Full-page app skeleton shown while auth initializes.
 * Mimics the AppShell layout: content area + bottom nav.
 */
export function AppSkeleton() {
  return (
    <div className="flex flex-col min-h-dvh bg-background">
      <main className="flex-1 p-5 flex flex-col gap-5">
        <Skeleton className="h-6 w-6 rounded" />
        <Skeleton className="h-12 w-48" />
        <Skeleton className="h-6 w-56" />
        <div className="flex gap-2 mt-2">
          <Skeleton className="h-8 w-16 rounded-full" />
          <Skeleton className="h-8 w-20 rounded-full" />
          <Skeleton className="h-8 w-18 rounded-full" />
        </div>
        <div className="flex flex-col gap-3 mt-4">
          <Skeleton className="h-20 w-full rounded-xl" />
          <Skeleton className="h-20 w-full rounded-xl" />
          <Skeleton className="h-20 w-full rounded-xl" />
        </div>
      </main>
      {/* Bottom nav skeleton */}
      <div className="border-t border-border px-6 py-3 flex justify-between">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="flex flex-col items-center gap-1"
          >
            <Skeleton className="h-6 w-6 rounded" />
            <Skeleton className="h-3 w-10" />
          </div>
        ))}
      </div>
    </div>
  );
}
